import recommendApi from "../../../api/account/recommend";

const state = {
  list: []
};

const getters = {};

const mutations = {
  // 存个列表
  setLst(state, { data }) {
    state.list = data;
  }
};

const actions = {
  // 获取列表
  getLst({ state }, { params, callback }) {
    console.log(state);
    recommendApi.getLstApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/recommend.js